import { useCallback, useMemo, useState } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useAxios } from "../../hooks";
import NoRowOverlay from "../common/NoRowOverlay";
import { useSetRecoilState } from "recoil";
import { withAlert } from "../../recoil/snackbar";
import ComfirmDialog from "../common/ConfirmDialog";
import { getDateTime } from "../../utilities/getDateTime";
import { Button, Typography } from "@mui/material";

export default function AnnoucementList({ handleOnSelecting }) {
  const api = useAxios();
  const queryClient = useQueryClient();

  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(25);
  const [open, setOpen] = useState(false);
  const openAlert = useSetRecoilState(withAlert);
  const [data, setData] = useState({ annoucement_id: "" });

  const handleOpen = useCallback(() => {
    setOpen((prev) => !prev);
  }, []);

  const { data: res, isLoading } = useQuery(
    `internal-announcement_list`,
    () => {
      return api.get(`/api/announcement/i/list`);
    }
  );

  const { mutate } = useMutation(
    () => {
      return api.delete(`/api/announcement/i/${data.annoucement_id}`);
    },
    {
      onSuccess: (res) => {
        openAlert({
          status: res.status,
          detail:
            typeof res.data.message === "string"
              ? res.data.message
              : res.data.message[0],
        });
        queryClient.invalidateQueries(`internal-announcement_list`);
      },
    }
  );

  const columns = useMemo(
    () => [
      { field: "id", headerName: "ID", minWidth: 90, flex: 0.5 },
      { field: "subject", headerName: "Subject", minWidth: 100, flex: 1 },
      {
        field: "body",
        headerName: "Body",
        minWidth: 200,
        flex: 1.5,
      },
      { field: "is_public", headerName: "Is Public", minWidth: 100, flex: 1 },
      {
        field: "created_by",
        headerName: "Created By",
        minWidth: 100,
        flex: 1,
      },
      {
        field: "created_at",
        headerName: "Created At",
        minWidth: 100,
        flex: 1,
        valueFormatter: (params) => getDateTime(params.value),
      },
      {
        field: "updated_at",
        headerName: "Updated At",
        minWidth: 100,
        flex: 1,
        valueFormatter: (params) => getDateTime(params.value),
      },
      {
        field: "action",
        headerName: "Action",
        sortable: false,
        minWidth: 100,
        flex: 1,
        renderCell: (params) => (
          <Button
            variant="outlined"
            color="error"
            size="small"
            sx={{
              height: "30px",
              width: "100px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
            onClick={() => {
              setData({
                annoucement_id: params.id,
              });
              handleOpen();
            }}
          >
            <Typography sx={{ fontSize: "11px", lineHeight: 1 }}>
              Delete
            </Typography>
          </Button>
        ),
      },
    ],
    []
  );

  return (
    <>
      <DataGrid
        columns={columns}
        rows={res?.data ?? []}
        loading={isLoading}
        checkboxSelection
        pagination
        initialState={{
          pagination: {
            paginationModel: { pageSize: 25, page: 0 },
          },
          columns: {
            columnVisibilityModel: {
              created_by: false,
            },
          },
        }}
        components={{
          Toolbar: GridToolbar,
          NoRowsOverlay: NoRowOverlay,
        }}
        onSelectionModelChange={handleOnSelecting}
        page={page}
        pageSize={pageSize}
        onPageChange={(v) => setPage(v)}
        onPageSizeChange={(v) => setPageSize(v)}
      />
      <ComfirmDialog
        open={open}
        handleClose={handleOpen}
        handleClickOpen={handleOpen}
        handleOnConfirm={mutate}
      />
    </>
  );
}
